import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PageHeader({ overline, title, sub, back = true }) {
  return (
    <section className="relative pt-32 md:pt-40 pb-12 md:pb-16 bg-[var(--sci-bg)] bg-grid-faint border-b border-[var(--sci-border)] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {back && (
          <Link
            to="/"
            data-testid="page-back-home"
            className="inline-flex items-center gap-2 text-xs font-mono-sci tracking-wider text-[var(--sci-text-muted)] hover:text-[var(--sci-teal)] transition-colors mb-8"
          >
            <ArrowLeft size={12} />
            BACK TO PUBLISHER
          </Link>
        )}
        <div className="flex items-center gap-3 mb-5">
          <span className="inline-block w-8 h-px bg-[var(--sci-teal)]" />
          <span className="overline text-[var(--sci-teal)]">{overline}</span>
        </div>
        <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[var(--sci-navy)] tracking-tight leading-[1.02]">
          {title}
        </h1>
        {sub && (
          <p className="mt-6 max-w-2xl text-[var(--sci-text-muted)] leading-relaxed text-base md:text-lg">
            {sub}
          </p>
        )}
      </div>
    </section>
  );
}
